module.exports = __webpack_public_path__ + "static/media/book.ee809753.JPG";